import React from 'react'
import FeaturesSection from '../UAEPageComponents/FeaturesSection'
import { OtherFeaturesDataRestaurants, OtherFeaturesDataRetail, UAERestaurantsFeatures, UAERetailFeatures } from '../../../constants/common'
import HeaderSection from '../UAEPageComponents/HeaderSection'
import OtherFeatures from '../UAEPageComponents/OtherFeatures'
import OutletTypes from '../UAEPageComponents/OutletTypes'
import styles from '../../../styles/UAEPageComponents.module.css'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import BusinessUnlockSectionUAE from '@/components/HomeLanding/HomeLandingComponents/BusinessUnlockSectionUAE'
import ConnectWithUsUAE from '@/components/HomeLanding/HomeLandingComponents/ConnectWithUsUAE'
import TestimonialSectionUAE from '@/components/HomeLanding/HomeLandingComponents/TestimonialSectionUAE'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import ContactSection from '../UAEPageComponents/ContactSection'
import BlogsAndVideos from '@/components/HomeLanding/HomeLandingComponents/BlogsAndVideos'
import UAEBlogsSection from '@/components/HomeLanding/HomeLandingComponents/UAEBlogsSection'
import ContqactSection from '../UAEPageComponents/ContactSection'
import { QbExperience } from '@/components/qbStrap'

const DesktopRestaurants = () => {
  const UAERestaurantsHeader = {
    firstTitle: "Next-Gen Point of Sale & Restaurant",
    secondTitle: "Management Solution",
    description: "From fine-dining restaurants to quick-service cafés, businesses across the UAE rely on speed, consistency and great customer experiences. Trusted by thousands of restaurants, QueueBuster’s Restaurant POS Billing Software helps manage billing, inventory, staff operations and VAT compliance with ease, making day-to-day restaurant operations smoother and more efficient.",
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "50rem",
      bgheight: "45rem",
      bgtop: "5%",
      bgleft: "14%",
      bgbottom: "10%",
      bgright: "10%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/uae-restaurants/restaurant_mainImg.webp",
        alt: "QueueBuster for Restaurants",
        width: "45rem",
        height: "40rem",
        bottom: "0",
        right: "0"
      },
      img1: {
        src: "/assets/uae-restaurants/Schedule.svg",
        alt: "Quick Bill",
        width: "17rem",
        height: "17rem",
        top: "5rem",
        left: "10%",
        zindex: 10
      },
      img2: {
        src: "/assets/uae-restaurants/discount.svg",
        alt: "Schedule",
        width: "15rem",
        height: "5.5rem",
        bottom: "35%",
        left: "5%",
        zindex: 10
      },
      img3: {
        src: "/assets/uae-restaurants/Frame.svg",
        alt: "Plane Image",
        width: "28rem",
        height: "18rem",
        top: "0%",
        right: "-4rem"
      },

      strVector1: {
        src: "/assets/UAERetailPage/Vector.svg",
        alt: "Vector 1",
        width: "2rem",
        height: "2rem",
        top: "18.5%",
        left: "30%"
      },
      
      strVector3: {
        src: "/assets/UAERetailPage/Vector2.svg",
        alt: "Vector 3",
        width: "2rem",
        height: "2rem",
        bottom: "25%",
        right: "-3%"
      },

    }
  }
  
  const OutletTypesData = [
    {
      image: "/assets/restaurantsInd/OutletTypesImg1.png",
      title: "Fine Dine",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/restaurantsInd/OutletTypesImg2.png",
      title: "Quick Service Restaurants",
      hoverColor: "#225590"
    },
    {
      image: "/assets/restaurantsInd/OutletTypesImg3.png",
      title: "Food Truck",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/sweets.png",
      title: "Sweet Shops",
      hoverColor: "#225590"
    },
    {
      image: "/assets/restaurantsInd/OutletTypesImg5.png",
      title: "Bars & Pubs",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/restaurantsInd/OutletTypesImg6.png",
      title: "Train Catering",
      hoverColor: "#225590"
    },
    {
      image: "/assets/restaurantsInd/Cloud_Kitchen.png",
      title: "Cloud Kitchen",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/restaurantsInd/OutletTypesImg8.png",
      title: "Food Court",
      hoverColor: "#225590"
    },
  ]

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          Why is QueueBuster POS ideal for UAE restaurants?
        </span>
      ),
      des: "QueueBuster POS is VAT and ZATCA compliant, supports multi-outlet operations, and simplifies billing, stock, and staff management. The UAE F&B sector has specific compliance and operational demands that generic POS systems often fall short on, QueueBuster is built with those local requirements in mind. This software gives you the tools to stay compliant, stay organised and keep service running without friction.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it handle multiple outlets and kitchens?
        </span>
      ),
      des: "Yes. Order synchronization is possible along with menu management and stock management among different outlets as well as cloud kitchens. All the outlets have their separate reporting system while central management can still have complete visibility of all operations from one single dashboard. It becomes very easy to measure the performance of different branches individually along with staff management per location.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Is it suitable for small cafes as well as large restaurants?
        </span>
      ),
      des: "Definitely. QueueBuster is scalable according to your needs, whether it’s for a standalone shop or an extensive chain of stores. A coffee shop would get started fast with basic functionalities, such as billing, managing menus, and generating reports. With business expansion, you can add more functionalities, including multiple branch synchronization, rewards program, and kitchen displays, all within the same platform.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it support bilingual invoices and menus?
        </span>
      ),
      des: "Indeed. Create invoices in both English and Arabic languages and create bilingual menus as well. This is crucial in UAE restaurants where customers from varied backgrounds visit and where suppliers are more comfortable dealing with invoices in Arabic. It will also make it easier to train your staff members.",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it integrate with delivery apps?
        </span>
      ),
      des: "Absolutely. The QueueBuster is designed to integrate seamlessly with all leading food delivery and aggregation platforms in the United Arab Emirates. This makes sure that your POS and kitchen receive all incoming deliveries automatically, without you having to enter the orders manually again, thus ensuring faster and more efficient service, especially when it comes to busy periods. Your inventory will also stay up-to-date at all times.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does it help with VAT compliance?
        </span>
      ),
      des: "Through the provision of invoices, tax reports, and even automatic submission services for your taxes. Each business transaction will be documented correctly, with tax allocation in mind, thus making the process of reconciling at the end of each period simple. In this way, FTA submissions become easy without fear of committing mistakes.",
      id: 6,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Is there a mobile app for restaurant owners?
        </span>
      ),
      des: "Yes. The QueueBuster’s mobile application allows you to oversee orders, give discounts approval, and monitor sales in real-time. There’s no need to stand behind the counter to keep abreast of everything that is going on in your restaurant; all of this information can be monitored through your mobile device. This product is aimed specifically at restaurant owners and managers.",
      id: 7,
      activeIndex: 0,
    },

  ]

  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={UAERestaurantsHeader} />

      <FeaturesSection
        data={UAERestaurantsFeatures}
        title={"Features That Fit Your Business"} />

      <OtherFeatures
        data={OtherFeaturesDataRestaurants}
        title={<>Other Important Features for <br />Fine Dine Restaurant POS Software</>} />

      <OutletTypes title={"Restaurants Types"} data={OutletTypesData} />

      <div className={styles.resposiveSections}>
        <QbExperience
          videoSrc="https://www.youtube.com/embed/nGcE20KSjYY?si=Uh9A6RNt7bRBwzlL"
          header="Quick Walkthrough"
          title="Watch First, Decide Later!"
          description="Whether you run a fine dine restaurant, a cafe, or a food court, QueueBuster is built to handle it all. See how restaurants across the UAE are running smarter with QueueBuster."
        />
        <AwardsSection /> 
      <div ><BusinessUnlockSectionUAE /></div>
      <div><ConnectWithUsUAE /></div>
      </div>
      <div>  <NewFaqSection FaqTableData={faqs} heading={"FAQs for UAE Restaurant POS Software"}/>  </div>

      <div>
        <ContqactSection 
        title="Couldn’t Find What You Wanted?"
        description= {<>Worry not, just send us your inquiry and wait while our Restaurant POS <br /> experts contact you.</>}
        buttonText="Request a callback"
      />
      </div>

      <div >
        <UAEBlogsSection />
      </div>
    </div>
  )
}



export default DesktopRestaurants
